import { Controller, useFormContext } from "react-hook-form";
import InputButtonGroup from "./InputButtonGroup";

function SingleSelectField({
  name,
  label,
  options,
  fullWidth,
  required,
  requiredText = "This field is required",
  validation,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const rules = {
    ...(required && { required: requiredText }),
    ...(validation && { validate: validation }),
  };
  return (
    <fieldset>
      {label && (
        <label>
          {label}
          {!required && <span className="label-optional"> (Optional)</span>}
        </label>
      )}
      <div className={`inputgroup${fullWidth ? " full-width" : ""}`}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <InputButtonGroup options={options} {...field} />
          )}
        />
      </div>
      <span className="input-error">{errors?.[name]?.message}</span>
    </fieldset>
  );
}

export default SingleSelectField;
